<script setup>
import LoginForm from "@/components/support/SupportLoginForm.vue";
</script>

<template>
  <LoginForm />
</template>
